import type { FunctionComponent } from "react";

import { Container, SwipeLeftArea, SwipeRightArea } from "./styles";

export type Props = {
  handleGoToNextPage: () => void;
  handleGoToPreviousPage: () => void;
};

export const FloatClickableArea: FunctionComponent<Props> = ({
  handleGoToNextPage,
  handleGoToPreviousPage,
}) => (
  <Container>
    <SwipeLeftArea onClick={handleGoToPreviousPage} />
    <SwipeRightArea onClick={handleGoToNextPage} />
  </Container>
);
